module.exports = __webpack_public_path__ + "img/zh1-1.8f80075c.jpg";